/**
 * Generated by orval v6.31.0 🍺
 * Do not edit manually.
 * Ledg API
 * API for managing financial activities and transactions
 * OpenAPI spec version: 2.0.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query'
import type {
  MutationFunction,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query'
import * as axios from 'axios';
import type {
  AxiosError,
  AxiosRequestConfig,
  AxiosResponse
} from 'axios'
import type {
  ApiUserImportSource,
  CreateImportSourceRequest,
  DeleteImportOperationResponse,
  DeleteImportSourceActivitiesResponse,
  EnrichedStatementParsingResult,
  ErrorResponse,
  GetUserImportSourcesResponse,
  UpdateImportSourceRequest
} from './client.schemas'




/**
 * @summary Delete a single import operation and its orphaned data
 */
export const deleteImportOperation = (
    operationId: string, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<DeleteImportOperationResponse>> => {
    
    return axios.default.delete(
      `/v2/imports/operations/${operationId}`,options
    );
  }



export const getDeleteImportOperationMutationOptions = <TError = AxiosError<void | ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteImportOperation>>, TError,{operationId: string}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof deleteImportOperation>>, TError,{operationId: string}, TContext> => {
const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteImportOperation>>, {operationId: string}> = (props) => {
          const {operationId} = props ?? {};

          return  deleteImportOperation(operationId,axiosOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteImportOperationMutationResult = NonNullable<Awaited<ReturnType<typeof deleteImportOperation>>>
    
    export type DeleteImportOperationMutationError = AxiosError<void | ErrorResponse>

    /**
 * @summary Delete a single import operation and its orphaned data
 */
export const useDeleteImportOperation = <TError = AxiosError<void | ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteImportOperation>>, TError,{operationId: string}, TContext>, axios?: AxiosRequestConfig}
): UseMutationResult<
        Awaited<ReturnType<typeof deleteImportOperation>>,
        TError,
        {operationId: string},
        TContext
      > => {

      const mutationOptions = getDeleteImportOperationMutationOptions(options);

      return useMutation(mutationOptions);
    }
    /**
 * @summary Get user import sources (v2 API)
 */
export const getUserImportSources = (
     options?: AxiosRequestConfig
 ): Promise<AxiosResponse<GetUserImportSourcesResponse>> => {
    
    return axios.default.get(
      `/v2/imports/sources`,options
    );
  }


export const getGetUserImportSourcesQueryKey = () => {
    return [`/v2/imports/sources`] as const;
    }

    
export const getGetUserImportSourcesQueryOptions = <TData = Awaited<ReturnType<typeof getUserImportSources>>, TError = AxiosError<void | ErrorResponse>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUserImportSources>>, TError, TData>>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetUserImportSourcesQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getUserImportSources>>> = ({ signal }) => getUserImportSources({ signal, ...axiosOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getUserImportSources>>, TError, TData> & { queryKey: QueryKey }
}

export type GetUserImportSourcesQueryResult = NonNullable<Awaited<ReturnType<typeof getUserImportSources>>>
export type GetUserImportSourcesQueryError = AxiosError<void | ErrorResponse>

/**
 * @summary Get user import sources (v2 API)
 */
export const useGetUserImportSources = <TData = Awaited<ReturnType<typeof getUserImportSources>>, TError = AxiosError<void | ErrorResponse>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUserImportSources>>, TError, TData>>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetUserImportSourcesQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * @summary Create a new import source
 */
export const createImportSource = (
    createImportSourceRequest: CreateImportSourceRequest, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<ApiUserImportSource>> => {
    
    return axios.default.post(
      `/v2/imports/sources`,
      createImportSourceRequest,options
    );
  }



export const getCreateImportSourceMutationOptions = <TError = AxiosError<ErrorResponse | void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createImportSource>>, TError,{data: CreateImportSourceRequest}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof createImportSource>>, TError,{data: CreateImportSourceRequest}, TContext> => {
const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createImportSource>>, {data: CreateImportSourceRequest}> = (props) => {
          const {data} = props ?? {};

          return  createImportSource(data,axiosOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CreateImportSourceMutationResult = NonNullable<Awaited<ReturnType<typeof createImportSource>>>
    export type CreateImportSourceMutationBody = CreateImportSourceRequest
    export type CreateImportSourceMutationError = AxiosError<ErrorResponse | void>

    /**
 * @summary Create a new import source
 */
export const useCreateImportSource = <TError = AxiosError<ErrorResponse | void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createImportSource>>, TError,{data: CreateImportSourceRequest}, TContext>, axios?: AxiosRequestConfig}
): UseMutationResult<
        Awaited<ReturnType<typeof createImportSource>>,
        TError,
        {data: CreateImportSourceRequest},
        TContext
      > => {

      const mutationOptions = getCreateImportSourceMutationOptions(options);

      return useMutation(mutationOptions);
    }
    /**
 * @summary Get a specific import source by ID
 */
export const getImportSource = (
    sourceId: string, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<ApiUserImportSource>> => {
    
    return axios.default.get(
      `/v2/imports/sources/${sourceId}`,options
    );
  }


export const getGetImportSourceQueryKey = (sourceId: string,) => {
    return [`/v2/imports/sources/${sourceId}`] as const;
    }

    
export const getGetImportSourceQueryOptions = <TData = Awaited<ReturnType<typeof getImportSource>>, TError = AxiosError<void | ErrorResponse>>(sourceId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getImportSource>>, TError, TData>>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetImportSourceQueryKey(sourceId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getImportSource>>> = ({ signal }) => getImportSource(sourceId, { signal, ...axiosOptions });

      

      

   return  { queryKey, queryFn, enabled: !!(sourceId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getImportSource>>, TError, TData> & { queryKey: QueryKey }
}

export type GetImportSourceQueryResult = NonNullable<Awaited<ReturnType<typeof getImportSource>>>
export type GetImportSourceQueryError = AxiosError<void | ErrorResponse>

/**
 * @summary Get a specific import source by ID
 */
export const useGetImportSource = <TData = Awaited<ReturnType<typeof getImportSource>>, TError = AxiosError<void | ErrorResponse>>(
 sourceId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getImportSource>>, TError, TData>>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetImportSourceQueryOptions(sourceId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * @summary Update an existing import source
 */
export const updateImportSource = (
    sourceId: string,
    updateImportSourceRequest: UpdateImportSourceRequest, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<ApiUserImportSource>> => {
    
    return axios.default.put(
      `/v2/imports/sources/${sourceId}`,
      updateImportSourceRequest,options
    );
  }



export const getUpdateImportSourceMutationOptions = <TError = AxiosError<ErrorResponse | void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateImportSource>>, TError,{sourceId: string;data: UpdateImportSourceRequest}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof updateImportSource>>, TError,{sourceId: string;data: UpdateImportSourceRequest}, TContext> => {
const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateImportSource>>, {sourceId: string;data: UpdateImportSourceRequest}> = (props) => {
          const {sourceId,data} = props ?? {};

          return  updateImportSource(sourceId,data,axiosOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UpdateImportSourceMutationResult = NonNullable<Awaited<ReturnType<typeof updateImportSource>>>
    export type UpdateImportSourceMutationBody = UpdateImportSourceRequest
    export type UpdateImportSourceMutationError = AxiosError<ErrorResponse | void>

    /**
 * @summary Update an existing import source
 */
export const useUpdateImportSource = <TError = AxiosError<ErrorResponse | void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateImportSource>>, TError,{sourceId: string;data: UpdateImportSourceRequest}, TContext>, axios?: AxiosRequestConfig}
): UseMutationResult<
        Awaited<ReturnType<typeof updateImportSource>>,
        TError,
        {sourceId: string;data: UpdateImportSourceRequest},
        TContext
      > => {

      const mutationOptions = getUpdateImportSourceMutationOptions(options);

      return useMutation(mutationOptions);
    }
    /**
 * @summary Delete an import source
 */
export const deleteImportSource = (
    sourceId: string, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {
    
    return axios.default.delete(
      `/v2/imports/sources/${sourceId}`,options
    );
  }



export const getDeleteImportSourceMutationOptions = <TError = AxiosError<void | ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteImportSource>>, TError,{sourceId: string}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof deleteImportSource>>, TError,{sourceId: string}, TContext> => {
const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteImportSource>>, {sourceId: string}> = (props) => {
          const {sourceId} = props ?? {};

          return  deleteImportSource(sourceId,axiosOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteImportSourceMutationResult = NonNullable<Awaited<ReturnType<typeof deleteImportSource>>>
    
    export type DeleteImportSourceMutationError = AxiosError<void | ErrorResponse>

    /**
 * @summary Delete an import source
 */
export const useDeleteImportSource = <TError = AxiosError<void | ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteImportSource>>, TError,{sourceId: string}, TContext>, axios?: AxiosRequestConfig}
): UseMutationResult<
        Awaited<ReturnType<typeof deleteImportSource>>,
        TError,
        {sourceId: string},
        TContext
      > => {

      const mutationOptions = getDeleteImportSourceMutationOptions(options);

      return useMutation(mutationOptions);
    }
    /**
 * This endpoint deletes all activities, activity groups, and related data for a specific
import source WITHOUT deleting the import source itself. Useful for re-syncing or
cleaning up bad imports while keeping the connection configured.
 * @summary Delete all activities for a specific import source
 */
export const deleteImportSourceActivities = (
    sourceId: string, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<DeleteImportSourceActivitiesResponse>> => {
    
    return axios.default.delete(
      `/v2/imports/sources/${sourceId}/activities`,options
    );
  }



export const getDeleteImportSourceActivitiesMutationOptions = <TError = AxiosError<void | ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteImportSourceActivities>>, TError,{sourceId: string}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof deleteImportSourceActivities>>, TError,{sourceId: string}, TContext> => {
const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteImportSourceActivities>>, {sourceId: string}> = (props) => {
          const {sourceId} = props ?? {};

          return  deleteImportSourceActivities(sourceId,axiosOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteImportSourceActivitiesMutationResult = NonNullable<Awaited<ReturnType<typeof deleteImportSourceActivities>>>
    
    export type DeleteImportSourceActivitiesMutationError = AxiosError<void | ErrorResponse>

    /**
 * @summary Delete all activities for a specific import source
 */
export const useDeleteImportSourceActivities = <TError = AxiosError<void | ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteImportSourceActivities>>, TError,{sourceId: string}, TContext>, axios?: AxiosRequestConfig}
): UseMutationResult<
        Awaited<ReturnType<typeof deleteImportSourceActivities>>,
        TError,
        {sourceId: string},
        TContext
      > => {

      const mutationOptions = getDeleteImportSourceActivitiesMutationOptions(options);

      return useMutation(mutationOptions);
    }
    /**
 * @summary Parse a broker statement
 */
export const parseStatement = (
     options?: AxiosRequestConfig
 ): Promise<AxiosResponse<EnrichedStatementParsingResult>> => {
    
    return axios.default.post(
      `/v2/imports/statement/parse`,undefined,options
    );
  }



export const getParseStatementMutationOptions = <TError = AxiosError<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof parseStatement>>, TError,void, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof parseStatement>>, TError,void, TContext> => {
const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof parseStatement>>, void> = () => {
          

          return  parseStatement(axiosOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ParseStatementMutationResult = NonNullable<Awaited<ReturnType<typeof parseStatement>>>
    
    export type ParseStatementMutationError = AxiosError<ErrorResponse>

    /**
 * @summary Parse a broker statement
 */
export const useParseStatement = <TError = AxiosError<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof parseStatement>>, TError,void, TContext>, axios?: AxiosRequestConfig}
): UseMutationResult<
        Awaited<ReturnType<typeof parseStatement>>,
        TError,
        void,
        TContext
      > => {

      const mutationOptions = getParseStatementMutationOptions(options);

      return useMutation(mutationOptions);
    }
    